<template>
  <div
    v-show="show"
    data-cy="loadingFullscreen"
    class="absolute top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-white"
  >
    <loading-skeleton class="flex flex-col items-center space-y-6">
      <div class="h-32 w-32 rounded-sm bg-gray-200" />
      <div class="flex flex-col items-center space-y-2">
        <div class="h-6 w-36 rounded-sm bg-gray-200" />
        <div class="h-6 w-80 rounded-sm bg-gray-200" />
      </div>
    </loading-skeleton>
  </div>
</template>

<script setup lang="ts">
import usePlatformScreenState from "@/composables/state/platformScreenState";
import LoadingSkeleton from "@/components/loading/LoadingSkeleton.vue";

defineProps<{
  show: boolean;
}>();

usePlatformScreenState();
</script>
